export const LOGO_URL =
  "https://www.themoviedb.org/assets/2/v4/logos/v2/blue_short-8e7b30f73a4020692ccca9c88bafe5dcb6f8a62a4c6bc55cd9ba82bb2cd95f6c.svg";
export const SEARCH_URL =
  "https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-28-search-blue-177462d06db81ff2a02aa022c1c0be5ba4200d7bd3f51091ed9298980e3a26a1.svg";
export const THUMBNAIL_URL =
  "https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-159-thumbnails-list-6e8977a4772e1bf4249bdaa9f63b091281a651009a84bca5b1a2b2fe65724da7.svg";
export const HOTSTAR_URL =
  "https://i.gadgets360cdn.com/large/disney_plus_hotstar_logo_1583901149861.jpg";
